import * as z$1 from "zod/v4";
//#region src/schemas/http/organization-member-openmeld-service-status.ts
const BOUNDED_ID_SCHEMA = z$1.string().trim().min(1).max(256);
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const organizationMemberOpenMeldServiceStateSchema = z$1.enum([
	"connected",
	"needs_attention",
	"not_connected",
	"unknown"
]);
const organizationMemberOpenMeldServiceStatusSchema = z$1.strictObject({
	state: organizationMemberOpenMeldServiceStateSchema,
	userId: BOUNDED_ID_SCHEMA
});
const centerAgentReadMemberOpenMeldServiceStatusBodySchema = z$1.strictObject({ memberUserId: BOUNDED_ID_SCHEMA });
const centerAgentReadMemberOpenMeldServiceStatusResponseSchema = z$1.strictObject({
	generatedAt: ISO_DATE_TIME_SCHEMA,
	member: organizationMemberOpenMeldServiceStatusSchema,
	organizationId: BOUNDED_ID_SCHEMA
});
const organizationMemberOpenMeldServiceStatusesResponseSchema = z$1.strictObject({
	generatedAt: ISO_DATE_TIME_SCHEMA,
	members: z$1.array(organizationMemberOpenMeldServiceStatusSchema),
	organizationId: BOUNDED_ID_SCHEMA
});
//#endregion
export { centerAgentReadMemberOpenMeldServiceStatusBodySchema, centerAgentReadMemberOpenMeldServiceStatusResponseSchema, organizationMemberOpenMeldServiceStateSchema, organizationMemberOpenMeldServiceStatusSchema, organizationMemberOpenMeldServiceStatusesResponseSchema };

//# sourceMappingURL=organization-member-openmeld-service-status.js.map